import React from 'react';
import loadable from '@loadable/component';

import getPageDataLoadingAPI from '../containers/pageDataLoadingAPI';
import NotFoundPage from '../containers/NotFoundPage/NotFoundPageView';
import PreviewResolverPage from '../containers/PreviewResolverPage/PreviewResolverPage';

// routeConfiguration needs to initialize containers first
// Otherwise, components will import form container eventually and
// at that point css bundling / imports will happen in wrong order.
import { NamedRedirect } from '../components';

const pageDataLoadingAPI = getPageDataLoadingAPI();

const AuthenticationPage = loadable(() => import(/* webpackChunkName: "AuthenticationPage" */ '../containers/AuthenticationPage/AuthenticationPage'));
const CheckoutPage = loadable(() => import(/* webpackChunkName: "CheckoutPage" */ '../containers/CheckoutPage/CheckoutPage'));
const CMSPage = loadable(() => import(/* webpackChunkName: "CMSPage" */ '../containers/CMSPage/CMSPageStyled'));
const ContactDetailsPage = loadable(() => import(/* webpackChunkName: "ContactDetailsPage" */ '../containers/ContactDetailsPage/ContactDetailsPageView'));
const EditListingPage = loadable(() => import(/* webpackChunkName: "EditListingPage" */ '../containers/EditListingPage/EditListingPage'));
const EmailVerificationPage = loadable(() => import(/* webpackChunkName: "EmailVerificationPage" */ '../containers/EmailVerificationPage/EmailVerificationPage'));
const InboxPage = loadable(() => import(/* webpackChunkName: "InboxPage" */ '../containers/InboxPage/InboxPageView'));
const MakeOfferPage = loadable(() => import(/* webpackChunkName: "MakeOfferPage" */ '../containers/MakeOfferPage/MakeOfferPage'));
const LandingPage = loadable(() => import(/* webpackChunkName: "LandingPage" */ '../containers/LandingPage/LandingPageStyled'));
const ListingPageCoverPhoto = loadable(() => import(/* webpackChunkName: "ListingPageCoverPhoto" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCoverPhoto'));
const ListingPageCarousel = loadable(() => import(/* webpackChunkName: "ListingPageCarousel" */ /* webpackPrefetch: true */ '../containers/ListingPage/ListingPageCarousel'));
const ManageListingsPage = loadable(() => import(/* webpackChunkName: "ManageListingsPage" */ '../containers/ManageListingsPage/ManageListingsPageView'));
const ManageAccountPage = loadable(() => import(/* webpackChunkName: "ManageAccountPage" */ '../containers/ManageAccountPage/ManageAccountPageView'));
const PasswordChangePage = loadable(() => import(/* webpackChunkName: "PasswordChangePage" */ '../containers/PasswordChangePage/PasswordChangePageView'));
const PasswordRecoveryPage = loadable(() => import(/* webpackChunkName: "PasswordRecoveryPage" */ '../containers/PasswordRecoveryPage/PasswordRecoveryPage'));
const PasswordResetPage = loadable(() => import(/* webpackChunkName: "PasswordResetPage" */ '../containers/PasswordResetPage/PasswordResetPage'));
const PaymentMethodsPage = loadable(() => import(/* webpackChunkName: "PaymentMethodsPage" */ '../containers/PaymentMethodsPage/PaymentMethodsPageView'));
const PrivacyPolicyPage = loadable(() => import(/* webpackChunkName: "PrivacyPolicyPage" */ '../containers/PrivacyPolicyPage/PrivacyPolicyPageStyled'));
const ProfilePage = loadable(() => import(/* webpackChunkName: "ProfilePage" */ '../containers/ProfilePage/ProfilePage'));
const ProfileSettingsPage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ '../containers/ProfileSettingsPage/ProfileSettingsPageView'));
const RequestQuotePage = loadable(() => import(/* webpackChunkName: "RequestQuotePage" */ '../containers/RequestQuotePage/RequestQuotePage'));
const SearchPageWithMap = loadable(() => import(/* webpackChunkName: "SearchPageWithMap" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithMap'));
const SearchPageWithGrid = loadable(() => import(/* webpackChunkName: "SearchPageWithGrid" */ /* webpackPrefetch: true */  '../containers/SearchPage/SearchPageWithGrid'));
const StripePayoutPage = loadable(() => import(/* webpackChunkName: "StripePayoutPage" */ '../containers/StripePayoutPage/StripePayoutPageView'));
const DashboardPage = loadable(() => import(/* webpackChunkName: "DashboardPage" */ '../containers/DashboardPage/DashboardPage'));
const SchedulePage = loadable(() => import(/* webpackChunkName: "SchedulePage" */ '../containers/SchedulePage/SchedulePage'));
const SearchPageView = loadable(() => import(/* webpackChunkName: "SearchPageView" */ '../containers/SearchPage/SearchPageView'));
const ActivityDetailPage = loadable(() => import(/* webpackChunkName: "ActivityDetailPage" */ '../containers/ActivityDetailPage/ActivityDetailPage'));
const NewAuthPage = loadable(() => import(/* webpackChunkName: "NewAuthPage" */ '../containers/NewAuthPage/NewAuthPage'));
const NewPasswordRecoveryPage = loadable(() => import(/* webpackChunkName: "NewPasswordRecoveryPage" */ '../containers/NewPasswordRecoveryPage/NewPasswordRecoveryPage'));
const NewPasswordResetPage = loadable(() => import(/* webpackChunkName: "NewPasswordResetPage" */ '../containers/NewPasswordResetPage/NewPasswordResetPage'));
const NewEmailVerificationPage = loadable(() => import(/* webpackChunkName: "NewEmailVerificationPage" */ '../containers/NewEmailVerificationPage/NewEmailVerificationPage'));
const VendorDashboardPage = loadable(() => import(/* webpackChunkName: "VendorDashboardPage" */ '../containers/VendorDashboardPage/VendorDashboardPage'));
const VendorSessionsPage = loadable(() => import(/* webpackChunkName: "VendorSessionsPage" */ '../containers/VendorSessionsPage/VendorSessionsPage'));
const CreateSessionPage = loadable(() => import(/* webpackChunkName: "CreateSessionPage" */ '../containers/CreateSessionPage/CreateSessionPage'));
const CreateActivityPage = loadable(() => import(/* webpackChunkName: "CreateActivityPage" */ '../containers/CreateActivityPage/CreateActivityPage'));
const EditActivityPage = loadable(() => import(/* webpackChunkName: "EditActivityPage" */ '../containers/EditActivityPage/EditActivityPage'));
const VendorSignupPage = loadable(() => import(/* webpackChunkName: "VendorSignupPage" */ '../containers/VendorSignupPage/VendorSignupPage'));
const CampScoutPage = loadable(() => import(/* webpackChunkName: "CampScoutPage" */ '../containers/CampScoutPage/CampScoutPage'));
const TravelSettingsPage = loadable(() => import(/* webpackChunkName: "TravelSettingsPage" */ '../containers/TravelSettingsPage/TravelSettingsPage'));
const ProvidersPage = loadable(() => import(/* webpackChunkName: "ProvidersPage" */ '../containers/ProvidersPage/ProvidersPage'));
const CartCheckoutPage = loadable(() => import(/* webpackChunkName: "CartCheckoutPage" */ '../containers/CartCheckoutPage/CartCheckoutPage'));
const TermsOfServicePage = loadable(() => import(/* webpackChunkName: "TermsOfServicePage" */ '../containers/TermsOfServicePage/TermsOfServicePageStyled'));
const TransactionPage = loadable(() => import(/* webpackChunkName: "TransactionPage" */ '../containers/TransactionPage/TransactionPageView'));
const NoAccessPage = loadable(() => import(/* webpackChunkName: "NoAccessPage" */ '../containers/NoAccessPage/NoAccessPageView'));

// Styleguide helps you to review current components and develop new ones
const StyleguidePage = loadable(() => import(/* webpackChunkName: "StyleguidePage" */ '../containers/StyleguidePage/StyleguidePage'));

export const ACCOUNT_SETTINGS_PAGES = [
  'ContactDetailsPage',
  'PasswordChangePage',
  'StripePayoutPage',
  'PaymentMethodsPage',
  'ManageAccountPage'
];

export const DASHBOARD_PAGES = ['DashboardPage', 'DashboardBasePage'];
export const SCHEDULE_PAGES = ['SchedulePage'];
export const VENDOR_PAGES = [
  'VendorOverviewPage',
  'VendorActivitiesPage',
  'VendorSessionsPage',
  'CreateActivityPage',
  'EditActivityPage',
  'EditActivityPageCanonical',
  'CreateSessionPage',
  'EditSessionPage',
];
export const VENDOR_ACTIVITY_PAGES = [
  'CreateActivityPage',
  'EditActivityPage',
  'EditActivityPageCanonical',
  'CreateSessionPage',
  'EditSessionPage',
];

// https://en.wikipedia.org/wiki/Universally_unique_identifier#Nil_UUID
const draftId = '00000000-0000-0000-0000-000000000000';
const draftSlug = 'draft';

const RedirectToLandingPage = () => <NamedRedirect name="LandingPage" />;

// NOTE: Most server-side endpoints are prefixed with /api. Requests to those
// endpoints are indended to be handled in the server instead of the browser and
// they will not render the application. So remember to avoid routes starting
// with /api and if you encounter clashing routes see server/index.js if there's
// a conflicting route defined there.

// Our routes are exact by default.
// See behaviour from Routes.js where Route is created.
const routeConfiguration = (layoutConfig, accessControlConfig) => {
  const isSearchPageWithMap = layoutConfig.searchPage?.variantType === 'map';
  const SearchPage = isSearchPageWithMap ? SearchPageWithMap : SearchPageWithGrid;
  const ListingPage = layoutConfig.listingPage?.variantType === 'carousel' 
    ? ListingPageCarousel 
    : ListingPageCoverPhoto;

  const isPrivateMarketplace = accessControlConfig?.marketplace?.private === true;
  const authForPrivateMarketplace = isPrivateMarketplace ? { auth: true } : {};
  
  return [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      path: '/p/:pageId',
      name: 'CMSPage',
      component: CMSPage,
      loadData: pageDataLoadingAPI.CMSPage.loadData,
    },
    // NOTE: when the private marketplace feature is enabled, the '/s' route is disallowed by the robots.txt resource.
    // If you add new routes that start with '/s*' (e.g. /support), you should add them to the robotsPrivateMarketplace.txt file.
    {
      path: '/s',
      name: 'SearchPage',
      ...authForPrivateMarketplace,
      component: SearchPageView,
    },
    {
      path: '/s/:listingType',
      name: 'SearchPageWithListingType',
      ...authForPrivateMarketplace,
      component: SearchPageView,
    },
    {
      path: '/activity/:slug/:id/:variant',
      name: 'ActivityDetailPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ActivityDetailPage,
      loadData: pageDataLoadingAPI.ActivityDetailPage.loadData,
    },
    {
      path: '/activity/:slug/:id',
      name: 'ActivityDetailPage',
      component: ActivityDetailPage,
      loadData: pageDataLoadingAPI.ActivityDetailPage.loadData,
    },
    {
      path: '/activity/:id',
      name: 'ActivityDetailPageCanonical',
      component: ActivityDetailPage,
      loadData: pageDataLoadingAPI.ActivityDetailPage.loadData,
    },
    {
      path: '/dashboard/activities/create',
      name: 'CreateActivityPage',
      auth: true,
      component: CreateActivityPage,
      loadData: pageDataLoadingAPI.CreateActivityPage.loadData,
    },
    {
      path: '/dashboard/activities/new/:tab',
      name: 'NewActivityPage',
      auth: true,
      component: EditActivityPage,
      loadData: pageDataLoadingAPI.EditActivityPage.loadData,
    },
    {
      path: '/dashboard/activities/:activityId/sessions/new',
      name: 'CreateSessionPage',
      auth: true,
      component: CreateSessionPage,
      loadData: pageDataLoadingAPI.CreateSessionPage.loadData,
    },
    {
      path: '/dashboard/activities/:activityId/sessions/:sessionId/edit',
      name: 'EditSessionPage',
      auth: true,
      component: CreateSessionPage,
      loadData: pageDataLoadingAPI.CreateSessionPage.loadData,
    },
    {
      path: '/dashboard/activities/:slug/:id/:tab',
      name: 'EditActivityPage',
      auth: true,
      component: EditActivityPage,
      loadData: pageDataLoadingAPI.EditActivityPage.loadData,
    },
    {
      path: '/dashboard/activities/:id/:tab',
      name: 'EditActivityPageCanonical',
      auth: true,
      component: EditActivityPage,
      loadData: pageDataLoadingAPI.EditActivityPage.loadData,
    },
    {
      path: '/dashboard/sessions',
      name: 'VendorSessionsPage',
      auth: true,
      component: VendorSessionsPage,
      loadData: pageDataLoadingAPI.VendorSessionsPage.loadData,
    },
    {
      path: '/dashboard/overview',
      name: 'VendorOverviewPage',
      auth: true,
      component: VendorDashboardPage,
      loadData: pageDataLoadingAPI.VendorDashboardPage.loadData,
    },
    {
      // Alias — many NamedLinks reference this name (breadcrumbs, topbar, auth redirect)
      path: '/dashboard/overview',
      name: 'VendorDashboardPage',
      auth: true,
      component: VendorDashboardPage,
      loadData: pageDataLoadingAPI.VendorDashboardPage.loadData,
    },
    {
      path: '/dashboard/activities',
      name: 'VendorActivitiesPage',
      auth: true,
      component: VendorDashboardPage,
      loadData: pageDataLoadingAPI.VendorDashboardPage.loadData,
    },
    {
      path: '/providers',
      name: 'ProvidersPage',
      component: ProvidersPage,
      loadData: pageDataLoadingAPI.ProvidersPage.loadData,
    },
    {
      path: '/for-providers',
      name: 'VendorSignupPage',
      component: VendorSignupPage,
    },
    {
      path: '/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/l/:slug/:id',
      name: 'ListingPage',
      ...authForPrivateMarketplace,
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
      prioritizeMapLibraryLoading: true,
    },
    {
      path: '/l/:slug/:id/make-offer',
      name: 'MakeOfferPage',
      auth: true,
      component: MakeOfferPage,
      loadData: pageDataLoadingAPI.MakeOfferPage.loadData,
    },
    {
      path: '/l/:slug/:id/request-quote',
      name: 'RequestQuotePage',
      auth: true,
      component: RequestQuotePage,
      extraProps: { mode: 'request-quote' },
      loadData: pageDataLoadingAPI.RequestQuotePage.loadData,
    },
    {
      path: '/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
      prioritizeMapLibraryLoading: true,
    },
    {
      path: '/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="NewActivityPage"
          params={{ id: 'new', tab: 'basics' }}
        />
      ),
    },
    {
      path: '/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },

    // Canonical path should be after the `/l/new` path since they
    // conflict and `new` is not a valid listing UUID.
    {
      path: '/l/:id',
      name: 'ListingPageCanonical',
      ...authForPrivateMarketplace,
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
      prioritizeMapLibraryLoading: true,
    },
    {
      path: '/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/u/:slug/:id',
      name: 'ProfilePage',
      ...authForPrivateMarketplace,
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/u/:id',
      name: 'ProfilePageCanonical',
      ...authForPrivateMarketplace,
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/u/:slug/:id/:variant',
      name: 'ProfilePageVariant',
      auth: true,
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/u/:id/:variant',
      name: 'ProfilePageVariantCanonical',
      auth: true,
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },

    // Note: authenticating with IdP (e.g. Facebook) expects that /login path exists
    // so that in the error case users can be redirected back to the LoginPage
    // In case you change this, remember to update the route in server/api/auth/loginWithIdp.js
    {
      path: '/login',
      name: 'LoginPage',
      component: NewAuthPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/signup',
      name: 'SignupPage',
      component: NewAuthPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.NewAuthPage.loadData,
    },
    {
      path: '/signup/:userType',
      name: 'SignupForUserTypePage',
      component: NewAuthPage,
      extraProps: { tab: 'signup' },
      loadData: pageDataLoadingAPI.NewAuthPage.loadData,
    },
    {
      path: '/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
      loadData: pageDataLoadingAPI.AuthenticationPage.loadData,
    },
    {
      path: '/recover-password',
      name: 'PasswordRecoveryPage',
      component: NewPasswordRecoveryPage,
    },
    {
      path: '/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
    {
      path: '/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/order/:id',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: (params, ...rest) =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }, ...rest),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/order/:id/details',
      name: 'OrderDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="OrderDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/sale/:id',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: pageDataLoadingAPI.TransactionPage.loadData,
    },
    {
      path: '/sale/:id/details',
      name: 'SaleDetailsPageRedirect',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="SaleDetailsPage" params={{ id: props.params?.id }} />,
    },
    {
      path: '/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      path: '/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/account/manage',
      name: 'ManageAccountPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageAccountPage,
    },
    {
      path: '/dashboard/children/:childId',
      name: 'DashboardChildPage',
      auth: true,
      authPage: 'LoginPage',
      component: DashboardPage,
      loadData: pageDataLoadingAPI.DashboardPage.loadData,
    },
    {
      path: '/dashboard/:tab',
      name: 'DashboardPage',
      auth: true,
      authPage: 'LoginPage',
      component: DashboardPage,
      loadData: pageDataLoadingAPI.DashboardPage.loadData,
    },
    {
      path: '/dashboard',
      name: 'DashboardBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: DashboardPage,
      loadData: pageDataLoadingAPI.DashboardPage.loadData,
    },
    {
      path: '/schedule',
      name: 'SchedulePage',
      auth: true,
      authPage: 'LoginPage',
      component: SchedulePage,
      loadData: pageDataLoadingAPI.SchedulePage.loadData,
    },
    {
      path: '/checkout',
      name: 'CartCheckoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: CartCheckoutPage,
    },
    {
      path: '/campscout',
      name: 'CampScoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: CampScoutPage,
      loadData: pageDataLoadingAPI.CampScoutPage.loadData,
    },
    {
      path: '/travel-settings',
      name: 'TravelSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TravelSettingsPage,
      loadData: pageDataLoadingAPI.TravelSettingsPage.loadData,
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
      loadData: pageDataLoadingAPI.TermsOfServicePage.loadData,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
      loadData: pageDataLoadingAPI.PrivacyPolicyPage.loadData,
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/g/:group',
      name: 'StyleguideGroup',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component',
      name: 'StyleguideComponent',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      ...authForPrivateMarketplace,
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/no-:missingAccessRight',
      name: 'NoAccessPage',
      component: NoAccessPage,
    },
    {
      path: '/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /reset-password endpoint
    {
      path: '/reset-password',
      name: 'PasswordResetPage',
      component: NewPasswordResetPage,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /verify-email endpoint
    {
      path: '/verify-email',
      name: 'EmailVerificationPage',
      component: NewEmailVerificationPage,
    },
    // Do not change this path!
    //
    // The API expects that the application implements /preview endpoint
    {
      path: '/preview',
      name: 'PreviewResolverPage',
      component: PreviewResolverPage ,
    },
  ];
};

export default routeConfiguration;
